<template>
  <div class="chat-list-wrapper">
    <div class="chat-list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="chat-list" v-else>
      <template v-if="chatList.length > 0">
        <router-link class="chat-item" tag="div" v-for="item in chatList" :key="item.targetId" :to="{name: 'ChatRoom', params: {id: item.targetId}}">
          <div class="user-avatar">
            <div class="avatar"><img :src="item.multipartData.avatar" alt=""></div>
            <span class="notice-dot" v-if="item.unreadMessageCount > 0"></span>
          </div>
          <div class="chat-user-info">
            <div class="baseinfo">
              <div class="info-box">
                <div class="name">{{item.multipartData.username}}</div>
                <div class="userinfo">{{item.multipartData.gender | genderFilter}} | {{item.multipartData.birthday | ageFilter}}</div>
                <span class="status-tag booked" v-if="item.multipartData.enroll.status == 1">已预约</span>
                <span class="status-tag waitting" v-if="item.multipartData.enroll.status == 2">待诊疗</span>
                <span class="status-tag ing" v-if="item.multipartData.enroll.status == 3">诊疗中</span>
              </div>
              <div class="last-msg-time">{{item.latestMessage.sentTime | chatTimeFilter}}</div>
            </div>
            <div class="allergy">{{item.multipartData.allergy == '否认' ? '无过敏史' : item.multipartData.allergy == '不确定' ? '不确定过敏史' : item.multipartData.allergy}}</div>
            <div class="last-message" v-if="item.multipartData.enroll.status == 1">【患者已预约 {{item.multipartData.enroll.start_time | dateFilter('month')}} - {{item.multipartData.enroll.pre_end_time | timeFilter}} 复诊】</div>
            <div class="last-message" v-else>
              <span v-if="item.latestMessage.messageType == 'TextMessage'">{{item.latestMessage.content.content}}</span>
              <span v-else-if="item.latestMessage.messageType == 'ImageMessage'">[图片]</span>
              <span v-else-if="item.latestMessage.messageType == 'VoiceMessage'">[语音]</span>
              <span v-else-if="item.latestMessage.objectName == 'AnswerMsg'">[问诊单]</span>
              <span v-else-if="item.latestMessage.objectName == 'PreMsg'">[处方]</span>
              <span v-else-if="item.latestMessage.objectName == 'ReferMsg'">[转诊单]</span>
              <span v-else-if="item.latestMessage.messageType == 'CommandNotificationMessage' && item.latestMessage.content.name == 'FinishChat'">系统消息：本次诊疗已结束</span>
              <span v-else-if="item.latestMessage.messageType == 'CommandNotificationMessage' && item.latestMessage.content.name == 'OrderedChat'">
                <!-- 预约诊疗文案 -->
                <span v-if="item.latestMessage.content.data.type == 1">已预约{{item.latestMessage.content.data.startTime | dateFilter('month')}} - {{item.latestMessage.content.data.endTime | timeFilter}}的诊疗日程</span>
                <span v-if="item.latestMessage.content.data.type == 2">实时问诊发起成功</span>
              </span>
              <span v-else>[未知类型消息]</span>
            </div>
          </div>
        </router-link>
      </template>
      <!-- 空数据状态 -->
      <div class="empty-list" v-else>
        <icon icon-class="empty-room-doctor"></icon>
        <p>还没有患者的沟通</p>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .chat-list-wrapper{
    .chat-list-loading{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 23px;
    }
    .chat-list{
      padding-top: 4px;
      .chat-item{
        width: 100%;
        padding-top: 16px;
        display: flex;
        justify-content: flex-start;
        transition: all .1s;
        &:active{
          background: #F9F9F9;
        }
        .user-avatar{
          position: relative;
          width: 44px;
          flex-shrink: 0;
          margin-left: 16px;
          .avatar{
            width: 44px;
            height: 44px;
            overflow: hidden;
            border-radius: 50%;
            img{
              width: 100%;
            }
          }
          .notice-dot{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 10px;
            height: 10px;
            border: 2px solid #FFF;
            background: @error;
            border-radius: 50%;
          }
        }
        .chat-user-info{
          flex: 1;
          width: calc(100% - 72px);
          margin-left: 12px;
          border-bottom: 1px solid #EEE;
          padding-bottom: 18px;
          .baseinfo{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .info-box{
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              flex: 1;
              max-width: 85%;
              .name{
                font-size: 16px;
                line-height: 18px;
                color: @black;
                max-width: 45%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .userinfo{
                margin-left: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #666;
              }
              .status-tag{
                position: relative;
                margin-left: 12px;
                font-size: 12px;
                line-height: 14px;
                border-radius: 16px;
                padding-left: 9px;
                &::after{
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                }
                &.booked{
                  color: #E2AD2E;
                  &::after{
                    background: #E2AD2E;
                  }
                }
                &.waitting{
                  color: @xile;
                  &::after{
                    background: @xile;
                  }
                }
                &.ing{
                  color: #00848A;
                  &::after{
                    background: #00848A;
                  }
                }
              }
            }
            .last-msg-time{
              font-size: 12px;
              line-height: 12px;
              color: #999;
              margin-right: 16px;
            }
          }
          .allergy{
            display: inline-block;
            margin-top: 8px;
            padding: 0 4px;
            height: 22px;
            line-height: 22px;
            font-size: 14px;
            color: #666;
            background: #F3F3F3;
            max-width: 232px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .last-message{
            width: 100%;
            margin-top: 12px;
            padding-right: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 16px;
            color: @black;
            span{
              font-size: 14px;
              line-height: 14px;
            }
          }
        }
      }
      .empty-list{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 156px;
        svg{
          font-size: 72px;
          color: #DDD;
        }
        p{
          margin-top:12px;
          font-size: 15px;
          line-height: 15px;
          color: #CCC;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        chatList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo
      }
    },
    created() {
      let _this = this;
      let conversationTypes = [ RongIMLib.ConversationType.PRIVATE ];
      let count = 150;
      // 更新聊天列表数据
      RongIMClient.getInstance().getConversationList({
        onSuccess(list) {
          console.log(list);
          _this.$store.commit('setChatList', list);
          _this.chatList = _this.$store.state.chatList;
          if(list && list.length > 0) {
            let patientList = [];
            list.forEach(item => {
              patientList.push(item.targetId);
            })
            _this.$root.post('/getPatientList', {
              doc_id: _this.userInfo.user_id,
              pat_id: patientList
            }).then(data => {
              _this.dataDone = true;
              // 混合数据
              _this.chatList.forEach((item, index) => {
                data.forEach(stuff => {
                  if(parseInt(item.targetId) == parseInt(stuff.user_id)) {
                    _this.$set(item, 'multipartData', stuff);
                  }
                })
              })
            })
          }else {
            _this.dataDone = true;
          }
        }
      }, conversationTypes, count)
    },
    mounted() {
      if(this.chatList.length > 0) {
        console.log(this.chatList)
      }
    },
    methods: {},
    filters: {
      chatTimeFilter(time) {
        // 如果是当天返回时间，如果不是当天返回相对时间
        if(moment().isSame(time, 'day')) {
          return moment(time).format('HH:mm');
        }else {
          return moment(time).fromNow()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ConsultingRoom/list.vue